import type { GeneralConfig } from '@shared/types/Config';

export const landUseTypeConfig: GeneralConfig = {
    sortFieldMap: {},
};
